/**
 * @file フック：ユーザーエージェント処理
 */

// ライブラリ読み込み
import { useEffect } from "react";

/**
 * ユーザーエージェントに応じてbodyタグにclassを付与
 */
export const useUserAgent = () => {
    useEffect(() => {
        const body = document.querySelector("body");
        const ua = navigator.userAgent.toLowerCase();
        // Android
        if (ua.indexOf("android") > 0) {
            body.classList.add("is-android");
        }
        // iPad
        if (ua.indexOf("ipad") > 0) {
            body.classList.add("is-ipad");
        }
        // iPhone
        if (ua.indexOf("iphone") > 0) {
            body.classList.add("is-iphone");
        }
        // Edge
        if (ua.indexOf("edg") > 0) {
            body.classList.add("is-edge");
        }
        // Chrome
        else if (ua.indexOf("chrome") > 0) {
            body.classList.add("is-chrome");
        }
        // Safari
        else if (ua.indexOf("safari") > 0) {
            body.classList.add("is-safari");
        }
    }, []);
};
